import styled from 'styled-components';
import { getUrlWithToken } from '../../../utils/common';

export const Wrapper = styled.div`
  min-width: ${(props) => props.size}px;
  max-width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
  border-radius: 100%;
  border: 1.5px solid ${(props) => props.theme.colors.white};
  ${(props) => (props.onClick ? 'cursor: pointer;' : '')}

  &.more-circle .initials {
    font-size: 20px;
  }
`;

export const Image = styled.div.withConfig({
  shouldForwardProp: (prop) => !['source'].includes(prop),
})`
  background: url(${(props) => getUrlWithToken(props.source)});
  background-color: ${(props) => props.theme.colors.darkGreen};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
  height: 100%;
  border-radius: 100%;
`;

export const CircleName = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'bgColor',
})`
  background-color: ${({ bgColor }) => bgColor};
  text-align: center;
  width: 100%;
  height: 100%;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  @media ${(props) => props.theme.device.tabletL} {
    margin-right: 0;
  }

  .initials {
    line-height: 1;
    color: ${({ color }) => color};
    font-size: ${({ size }) => (size ? size / 2 : 18)}px;
    font-weight: 600;
  }
`;
